document.querySelectorAll('.audio-player-container').forEach((container) => {
  const audio = container.querySelector('.audio');
  const playButton = container.querySelector('.play-button');
  const timeline = container.querySelector('.timeline');
  const progress = container.querySelector('.audio-progress');
  const timeRemaining = container.querySelector('.time-remaining');
  const audioPlayer = container.querySelector('.audio-player');
  const audioTitle = container.querySelector('.audio-title');

  playButton.addEventListener('click', () => {
    if (audio.paused) {
      document.querySelectorAll('.audio').forEach((otherAudio) => {
        if (otherAudio !== audio) {
          otherAudio.pause();
        }
      });
      audio.play();
      playButton.classList.remove('paused');
    } else {
      audio.pause();
      playButton.classList.add('paused');
    }
  });

  audio.addEventListener('timeupdate', () => {
    const duration = audio.duration;
    const currentTime = audio.currentTime;
    const remainingTime = duration - currentTime;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = Math.floor(remainingTime % 60)
      .toString()
      .padStart(2, '0');
    timeRemaining.textContent = `${minutes}:${seconds}`;
    const progressPercent = (currentTime / duration) * 100;
    progress.style.width = `${progressPercent}%`;
  });

  timeline.addEventListener('click', (e) => {
    const timelineWidth = timeline.clientWidth;
    const clickX = e.offsetX;
    const duration = audio.duration;
    audio.currentTime = (clickX / timelineWidth) * duration;
  });

  audio.addEventListener('play', () => {
    playButton.classList.add('paused');
    audioPlayer.classList.add('playing');
    audioTitle.classList.add('c-main-bright');
  });

  audio.addEventListener('pause', () => {
    playButton.classList.remove('paused');
    audioPlayer.classList.remove('playing');
    audioTitle.classList.remove('c-main-bright');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const ratingGroups = [...document.querySelectorAll('.rating__options')];
  const submitBtn = document.getElementById('submit-rating');
  const scoreBox = document.getElementById('final-score');
  const averageScore = document.getElementById('average-score');

  function calculateAndUpdate() {
    let total = 0;
    let count = 0;

    ratingGroups.forEach((group) => {
      const selected = group.querySelector('input[type="radio"]:checked');
      if (selected) {
        const raw = parseInt(selected.value);
        const score = 5 - raw;
        total += score;
        count++;
      }
    });

    if (count > 0) {
      const avg = (total / count).toFixed(3).replace('.', ',');
      averageScore.textContent = avg;
      scoreBox.style.display = 'block';
    } else {
      averageScore.textContent = '0';
      scoreBox.style.display = 'none';
    }

    if (count === ratingGroups.length) {
      submitBtn.removeAttribute('disabled');
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
    }
  }

  document
    .querySelectorAll('.rating__options input[type="radio"]')
    .forEach((input) => {
      input.addEventListener('change', calculateAndUpdate);
    });

  calculateAndUpdate();
});
